export const PROTOCOL_FORM_GET_REQUEST = 'PROTOCOL_FORM_GET_REQUEST';
export const PROTOCOL_FORM_GET_SUCCESS = 'PROTOCOL_FORM_GET_SUCCESS';
export const PROTOCOL_FORM_GET_ERROR = 'PROTOCOL_FORM_GET_ERROR';
export const PROTOCOL_FORM_GET_BY_KEY_REQUEST = 'PROTOCOL_FORM_GET_BY_KEY_REQUEST';
export const PROTOCOL_FORM_GET_BY_KEY_SUCCESS = 'PROTOCOL_FORM_GET_BY_KEY_SUCCESS';
export const PROTOCOL_FORM_GET_BY_KEY_ERROR = 'PROTOCOL_FORM_GET_BY_KEY_ERROR';
export const PROTOCOL_FORM_ADD_REQUEST = 'PROTOCOL_FORM_ADD_REQUEST';
export const PROTOCOL_FORM_ADD_SUCCESS = 'PROTOCOL_FORM_ADD_SUCCESS';
export const PROTOCOL_FORM_ADD_ERROR = 'PROTOCOL_FORM_ADD_ERROR';
export const PROTOCOL_FORM_EDIT_REQUEST = 'PROTOCOL_FORM_EDIT_REQUEST';
export const PROTOCOL_FORM_EDIT_SUCCESS = 'PROTOCOL_FORM_EDIT_SUCCESS';
export const PROTOCOL_FORM_EDIT_ERROR = 'PROTOCOL_FORM_EDIT_ERROR';
export const PROTOCOL_FORM_DELETE_REQUEST = 'PROTOCOL_FORM_DELETE_REQUEST';
export const PROTOCOL_FORM_DELETE_SUCCESS = 'PROTOCOL_FORM_DELETE_SUCCESS';
export const PROTOCOL_FORM_DELETE_ERROR = 'PROTOCOL_FORM_DELETE_ERROR';
